import {
  Building2,
  BookOpen,
  CalendarRange,
  Plug,
  Network,
  Shield,
  Users,
} from 'lucide-react';
import type { ComponentType } from 'react';

/**
 * Вкладки раздела «Управление компанией» (AK-350).
 *
 * Каждая вкладка = сегмент URL (/company/<key>) — deep-link, F5 и шаринг
 * ссылки сохраняют активную вкладку (без JS-state). Порядок фиксирован
 * (совпадает с горизонтальной лентой в шапке).
 *
 * `soon` — placeholder-вкладка (RBAC v2 / справочники / интеграции): видна,
 * но контент — заглушка «Скоро».
 */
export interface CompanyTabDef {
  key: string;
  label: string;
  icon: ComponentType<{ className?: string }>;
  soon?: boolean;
}

export const COMPANY_TABS: CompanyTabDef[] = [
  { key: 'structure', label: 'Структура', icon: Network },
  { key: 'team', label: 'Команда', icon: Users },
  { key: 'roles', label: 'Роли и доступы', icon: Shield },
  { key: 'reference', label: 'Справочники', icon: BookOpen },
  // AK-434 / SA-03 — настройка сезона: имя, границы, окно планирования.
  // Первое сохранение открывает раздел «Планирование сезона» (гейт).
  { key: 'season', label: 'Сезон', icon: CalendarRange },
  // AK-738: борд статусов синхры AgroHistory — реализовано; остальные
  // интеграции (1С, Bitrix24) остаются заглушкой ниже борда.
  { key: 'integrations', label: 'Интеграции', icon: Plug },
  { key: 'profile', label: 'Профиль', icon: Building2 },
];

export const COMPANY_TAB_KEYS = COMPANY_TABS.map((t) => t.key);

/** Дефолтная вкладка при заходе на /company (index) — обзорный лендинг. */
export const COMPANY_DEFAULT_TAB = null; // null = лендинг-обзор
